import React,{useEffect,useState} from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from '../../components/CheckOut/CheckoutForm';
import Header from '../../components/Header/Header';
// import PaymentService from '../../Services/PaymentService';


const stripePromise = loadStripe('pk_test_51KDrvlSC7gIV5hteoNv3DuRiwJAmQFAJCG00XcWqoNeZdSb8lV2XmPzY13ARaD1eFcETEgzKnAKBTzdvKHxV22nL005rPYKZen');


const StripePaymentPage = () => {

    const [clientSecret, setClientSecret] = useState(null);

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        const response = await fetch('/server/subscription_portal_function/create-payment-intent', { method: 'POST' });
        const data = await response.json();
        setClientSecret(data.clientSecret);
      } catch (error) {
        console.error('Error fetching client secret:', error);
      }
    };

    fetchClientSecret();
  }, []);

  if (!clientSecret) {
    return <div>Loading...</div>;
  }
  return (
    <Header>
        <Elements stripe={stripePromise}options={{ clientSecret }}>
          <CheckoutForm />
    </Elements>
    </Header>
  );
};

export default StripePaymentPage;
